import { privateClient } from "@/api/privateClient";
import { SUPER_ADMIN_ENDPOINTS } from "../../endpoint";

export interface StudentCategory {
  id: number;
  name: string;
  description: string | null;
  is_active: boolean;
}

export interface CreateCategoryPayload {
  name: string;
  description?: string;
}

export interface UpdateCategoryPayload {
  name: string;
  description?: string;
}

export const fetchCategories = async (): Promise<StudentCategory[]> => {
  const { data } = await privateClient.get(SUPER_ADMIN_ENDPOINTS.STUDENT_CATEGORIES.LIST);
  return data.categories ?? data;
};

export const fetchActiveCategories = async (): Promise<StudentCategory[]> => {
  const { data } = await privateClient.get(SUPER_ADMIN_ENDPOINTS.STUDENT_CATEGORIES.LIST_ACTIVE);
  return data.categories ?? data;
};

export const createCategory = async (payload: CreateCategoryPayload): Promise<StudentCategory> => {
  const { data } = await privateClient.post(SUPER_ADMIN_ENDPOINTS.STUDENT_CATEGORIES.CREATE, payload);
  return data.category ?? data;
};

export const updateCategory = async (id: number, payload: UpdateCategoryPayload): Promise<StudentCategory> => {
  const { data } = await privateClient.put(SUPER_ADMIN_ENDPOINTS.STUDENT_CATEGORIES.UPDATE(id), payload);
  return data.category ?? data;
};

export const deactivateCategory = async (id: number): Promise<void> => {
  await privateClient.patch(SUPER_ADMIN_ENDPOINTS.STUDENT_CATEGORIES.DEACTIVATE(id));
};

export const reactivateCategory = async (id: number): Promise<void> => {
  await privateClient.patch(SUPER_ADMIN_ENDPOINTS.STUDENT_CATEGORIES.REACTIVATE(id));
};